<template>
  <router-view/>
</template>

<script>
  export default {
    created () {
      console.log("lastUpdate-260423");
    }
  };
</script>